import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { BracketedDiv, ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { StringProperExpression } from "../../../rule-engine-core/Expressions/Expressions/String/StringProperExpression";

export class StringProperExpressionEditor extends ExpressionRuleEditor<StringProperExpression> {
    render() {
        return (
            <>
                <ExpressionPiece>
                    <BracketedDiv>
                        <ExpressionValueRenderer el={this.ruleData!.value1!} />
                    </BracketedDiv>
                    <ExpressionPiece>to proper case</ExpressionPiece>
                </ExpressionPiece>
            </>
        );
    }
}
